import { ReportGenerationStage } from '@ankor-io/common/types/reports/generated-report'

export const REPORT_GENERATION_STAGE_LABELS: Record<ReportGenerationStage, string> = {
  [ReportGenerationStage.PREPARE_DATA]: 'Prepare Data',
  [ReportGenerationStage.TRANSFORM_DATA]: 'Transform Data',
  [ReportGenerationStage.UPLOAD_REPORT]: 'Upload Report',
}

export const REPORT_GENERATION_STAGE_ORDER: ReportGenerationStage[] = [
  ReportGenerationStage.PREPARE_DATA,
  ReportGenerationStage.TRANSFORM_DATA,
  ReportGenerationStage.UPLOAD_REPORT,
]

/** Maps ReportGenerationStage → run step `type` query param for list steps API */
export const REPORT_GENERATION_STAGE_TO_STEP_TYPE: Record<ReportGenerationStage, string> = {
  [ReportGenerationStage.PREPARE_DATA]: 'PREPARE_DATA',
  [ReportGenerationStage.TRANSFORM_DATA]: 'TRANSFORM',
  [ReportGenerationStage.UPLOAD_REPORT]: 'UPLOAD',
}
